import { useEffect, useState } from "react";
import { CardTaps } from "../../../../theme/Component/CardTaps";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _ConfigAdmin } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { toast } from "react-toastify";
import { Modal } from "../../../../theme/Component/Modal";
import { AccountEditor } from "../../../../editor/AccountEditor";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { BasicTable, MASK_NUMBER } from "../../../../theme/Component/BasicTable";

interface Props {
    Value: number;
    onChange: any;
    _label?: string;
}

interface form {
    IDAccount: number;
    Name: string;
}

export const EditorFunctionalAreaByEmployee = ({ Value, onChange, _label }: Props) => {

    const { lista, setLista, bean, setBean, handleChange, instance } = useDataBean(_ConfigAdmin)
    const [indexTap, setIndexTap] = useState(0);
    const [response, setResponse] = useState<Partial<form>>({});

    const [modal, setModal] = useState<any>({ name: "Busqueda de Plaza Laboral", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    let taps = [
        { id: 0, name: 'Buscar por Plaza Laboral y Tercero', disable: false },
        { id: 1, name: 'Buscar por Nombre de Plaza Laboral', disable: false }
    ];

    useEffect(() => {
        if (Value) {
            getValue()
        }
    }, [Value])

    const getValue = () => {
        instance.getFunctionalArea(Value).then(
            (resp) => {
                setBean(resp)
            }
        ).catch(
            err => {
                console.log(err);
                toast.error("No se Pudo obeter la informacion de la plaza")
            }
        )
    }

    const getAreaByEmployee = () => {
        instance.getFunctionalAreaByEmployee(response.IDAccount, null).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => {
                console.log(err);
                toast.error("Algo salio mal")
            }
        )
    }

    const getAreaByName = () => {
        instance.getFunctionalAreaByName(response.Name, null).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => {
                console.log(err);
                toast.error("Algo salio mal")
            }
        )
    }

    const head = [
        { title: 'ID', property: 'IDLn', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre de la Plaza', property: 'Name', visible: true },
        { title: 'Titular Plaza', property: 'AccountHolderName', visible: true },
        { title: 'Empleado', property: 'FunctionalAreaName', visible: true },
        { title: 'Ubicación Geográfica de la Plaza', property: 'SiteIDName', visible: true },
        { title: 'Tipo de Labor', property: 'LabourTypeName', visible: true },
        { title: 'Estado', property: 'StateName', visible: true }
    ]

    const setValue = () => {
        setModal({ ...modal, "view": false });
        onChange(bean)
    }

    return (
        <>
            <label>{_label ?? "Área Funcional"}</label>
            <span className="form-control text-wrap" style={{ minHeight: '35px' }} onClick={() => setModal({ ...modal, view: true })}>
                {bean.IDLn ? `${bean.IDLn}-${bean.FunctionalAreaName}` : "Seleccione una Plaza"}
            </span>

            <Modal modal={modal} updateModal={setModal} eventModal={() => {
                if (bean.IDLn) {
                    setValue();
                } else {
                    toast.error("Plaza no Valdia")
                }

            }} onSubmitLabel="Seccionar">
                <CardTaps index={indexTap} taps={taps} updateIndex={setIndexTap}>
                    <div className="row">
                        {indexTap === 0 &&
                            <div className="col-md-8">
                                <label>Tercero</label>
                                <AccountEditor idAccount={response.IDAccount} label="" onChange={(e) => { setResponse({ "IDAccount": e.IDAccount }) }} />
                            </div>
                        }
                        {indexTap === 1 &&
                            <div className="col-md-8">
                                <label>Nombre de Plaza Laboral</label>
                                <input type="text" className="form-control" value={response.Name} onChange={(e) => { setResponse({ "Name": e.target.value }) }} />
                            </div>
                        }
                        <div className="col-md-4 mt-4">
                            <BasicButton eventClick={() => {
                                if (indexTap === 0) {
                                    getAreaByEmployee();
                                } else if (indexTap === 1) {
                                    getAreaByName();
                                }
                            }} icon="ri-search-line" children={`Buscar`} />
                        </div>

                        <div className="col-md-12">
                            <BasicTable body={lista} head={head} rowSet={setBean} />
                        </div>
                    </div>
                </CardTaps>
            </Modal>
        </>
    )
}